import { render } from "./tenant_settings.html?vue&type=template&id=4b1b4162&external"
import script from "./tenant_settings.js?vue&type=script&lang=js&external"
export * from "./tenant_settings.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__